/**
 * @generated SignedSource<<3131d33e19b736ee8de5c40b51fa16ae>>
 * @relayHash 169962eb327aad26220fb2415e8f691a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID deb7ea5ed86d815721c53d38fd4ac937d1c1950f0bd776390f12d72497bf2093

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldsPageContentQuery$variables = {
  cloudId: string;
  preloadedFieldId: string;
  projectKey: string;
  shouldPreloadField: boolean;
};
export type FieldsPageContentQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isExplicitFieldAssociationsEnabled: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"DeepLinkSidebar" | "FieldsPageHeader">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsTable">;
};
export type FieldsPageContentQuery = {
  response: FieldsPageContentQuery$data;
  variables: FieldsPageContentQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isNumberFieldConfigurationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-ui-enabled.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colourful-single-select-fields-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "preloadedFieldId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldPreloadField"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "isExplicitFieldAssociationsEnabled"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v12 = {
  "kind": "ScalarField",
  "name": "scope"
},
v13 = {
  "kind": "ScalarField",
  "name": "typeName"
},
v14 = {
  "kind": "ScalarField",
  "name": "description"
},
v15 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v16 = {
  "kind": "ScalarField",
  "name": "hasMissingConfiguration"
},
v17 = {
  "kind": "ScalarField",
  "name": "canRemove"
},
v18 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v19 = {
  "kind": "ScalarField",
  "name": "canModifyOptions"
},
v20 = {
  "concreteType": "JiraFieldOptionConnection",
  "kind": "LinkedField",
  "name": "fieldOptions",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraFieldOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraFieldOption",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "optionId"
            },
            {
              "kind": "ScalarField",
              "name": "parentOptionId"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    },
                    (v9/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "fieldFormatConfig",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            },
            {
              "kind": "ScalarField",
              "name": "formatDecimals"
            }
          ],
          "type": "JiraNumberFieldFormatConfig"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "FieldsTable"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "FieldsPageHeader"
              },
              {
                "condition": "shouldPreloadField",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "preloadedFieldId",
                        "variableName": "preloadedFieldId"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DeepLinkSidebar"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "xsmall"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v8/*: any*/),
              {
                "kind": "ScalarField",
                "name": "optionsPerFieldLimit"
              },
              {
                "concreteType": "JiraFieldTypeGroupConnection",
                "kind": "LinkedField",
                "name": "projectFieldTypeGroups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldTypeGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldTypeGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsPerProjectLimit"
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsCount"
              },
              (v9/*: any*/),
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v9/*: any*/),
                                  (v7/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/)
                                ]
                              },
                              (v16/*: any*/),
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDelete"
                                  },
                                  (v18/*: any*/),
                                  (v19/*: any*/)
                                ]
                              },
                              (v20/*: any*/),
                              (v22/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isFieldLocked"
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v10/*: any*/),
                    "filters": [
                      "input"
                    ],
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v6/*: any*/),
              {
                "condition": "shouldPreloadField",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectWithIssueTypeIds",
                    "kind": "LinkedField",
                    "name": "projectWithVisibleIssueTypeIds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "preloadedField",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fieldId",
                            "variableName": "preloadedFieldId"
                          }
                        ],
                        "concreteType": "JiraFieldAssociationWithIssueTypes",
                        "kind": "LinkedField",
                        "name": "fieldAssociationWithIssueTypesByFieldId",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v7/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v20/*: any*/),
                          (v16/*: any*/),
                          {
                            "concreteType": "JiraFieldOperation",
                            "kind": "LinkedField",
                            "name": "fieldOperation",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/)
                            ]
                          },
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "deb7ea5ed86d815721c53d38fd4ac937d1c1950f0bd776390f12d72497bf2093",
    "metadata": {},
    "name": "FieldsPageContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "87afe89a1e0f48de789ee2102d35f9c1";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
